import axios from "axios";
import api from "../../../../../services/axios";

export const SaveBasicRecruitmentDetails = async (payload) => {
  try {
    const res = await api.post(
      "/Employee/RecruitmentLead/SaveBasicRecruitmentDetails",
      payload,
    );
    return res.data;
  } catch (error) {
    throw error?.response?.data || "Something went wrong";
  }
};

export const GetLeadDetailsByUID = async (leadUID) => {
  try {
    const res = await api.get(
      `/Employee/RecruitmentLead/GetLeadDetailsByUID?LeadUID=${leadUID}`,
    );
    return res?.data;
  } catch (error) {
    throw (
      error?.response?.data || "Something went wrong. Please try again later."
    );
  }
};

export const EditLeadDetails = async (formData) => {
  try {
    const res = await api.post(
      `/Employee/RecruitmentLead/UpdateRecruitmentLead`,
      formData,
      {
        headers: {
          "Content-Type": "multipart-form-data"
        },
      });
    return res?.data;
  } catch (error) {
    throw (
      error?.response?.data || "Something went wrong. Please try again later."
    );
  }
};

//Harshada Bhavsar - 11/05/2026
//Start Call API
export const StartCall = async (payload) => {
  try {
    const res = await api.post("/Employee/RecruitmentLead/StartCall", payload);

    return res?.data;
  } catch (error) {
    throw (
      error?.response?.data || "Something went wrong. Please try again later."
    );
  }
};

export const GetLeadTransferRequests = async (page, pageSize) => {
  try {
    const res = await api.get(`/Employee/RecruitmentLead/LeadTransferRequests?page=${page}&pageSize=${pageSize}`);
    return res?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const ApproveTransfer = async (requestUID,  remark) => {
  try {
    const res = await api.post("/Employee/RecruitmentLead/ApproveLeadTransferReq", { requestUID, remark });
    return res?.data;
  } catch (error) {
    return error?.response?.data;
  } 
};

export const RejectTransfer = async (requestUID,  remark) => {
  try {
    const res = await api.post("/Employee/RecruitmentLead/RejectLeadTransferReq", { requestUID, remark });
    return res?.data;
  } catch (error) {
    return error?.response?.data;
  } 
};

export const GetApprovedLeadTransferReq = async (page, pagesize) => {
  try {
    const res = await api.get(`/Employee/RecruitmentLead/GetApproveLeadTransferReq?page=${page}&pageSize=${pagesize}`);
    return res?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const GetRejectedLeadTransferReq = async (page, pagesize) => {
  try {
    const res = await api.get(`/Employee/RecruitmentLead/GetRejectedLeadTransferReq?page=${page}&pageSize=${pagesize}`);
    return res?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

//Harshada Bhavsar - 22/05/2026
//Get Recruitment History API
export const GetRecruitmentHistory = async (UID) => {
  try {
    const res = await api.get(
      "/Employee/RecruitmentLead/GetRecruitmentHistoryByUID",
      {
        params: {
          UID,
        },
      }
    );

    return res?.data;
  } catch (error) {
    if (
      error?.response?.data?.message === "No history found."
    ) {
      return {
        status: "fail",
        historyDetails: [],
        message: "No history found.",
      };
    }
    throw (
      error?.response?.data ||
      "Something went wrong. Please try again later."
    );
  }
};

//Harshada Bhavsar - 23/05/2026
//Get my Lead Transfer Requests
export const GetMyLeadTransferRequests = async (page, pageSize) => {
  try {
    const res = await api.get(`/Employee/RecruitmentLead/GetMyLeadTransferRequests?page=${page}&pageSize=${pageSize}`);
    return res?.data;
  } catch (error) {
    return error?.response?.data;
  }
};